import React from 'react';

const Logo = () => {
  return (
    <div className="flex items-center gap-3">
      <img 
        src="/logo.jpeg" 
        alt="IRScan Logo" 
        className="w-8 h-8 object-contain rounded-lg"
      />
      <span className="text-xl font-bold bg-gradient-to-r from-[#BFEA15] to-[#D9F273] bg-clip-text text-transparent">
        IRScan
      </span>
    </div>
  );
};

export default Logo;
